$(document).ready(function() {
    $('.w-btn').hide(); // hide banner 'Shop Now' button
    $('body').on('click', '.top-banner', function(){//banner should be unclickable
      return false;
    });
  
    $('#screen-protect').on('inview',function(event, isInView, visiblePartX, visiblePartY) {
      if (isInView) {
        console.log('element is now visible in the viewport!');
        if (visiblePartY =='top') {
          console.log('top part of element is visible!')
        } else if (visiblePartY =='bottom') {
          console.log('bottom part of element is visible!')
        } else {
          console.log('whole part of element is visible!');
        }
      }else {
        console.log('element has gone out of viewport!');
      }
    });
  });    
  
  function fadeOut() {
    setTimeout(function(){ $('.addedToCart_alert').fadeOut(); },2000);
  }
    
  var gettingClicked = 0;
  $(".navtab-item-sector").click(function(e){
    gettingClicked =1;
    $(".navtab-item-sector").removeClass("active");
  
    $(this).addClass('active');
    console.log('navtab-item-sector clicked');
  });
  
  // script to change tab text on mobile view
  const activefittab = document.getElementById("activefit");
  const comfortit = document.getElementById("comfortfit");
  
  if (window.innerWidth < 767) {
    activefittab.textContent = "Active-fit bands";
    comfortit.textContent = "Comfort-fit bands";
  } else{
    activefittab.textContent = "Active-fit watch bands";
    comfortit.textContent = "Comfort-fit watch bands";
  }
    
  $(document).ready(function(){
    $('.cartMinus').click(function(e) {
      var qty = $(this).parent().next('.input-box').val();
      qty = qty - 1;
  
      var variant_id=$(this).parent().parent('.inputwrap').siblings('.prod-btn').children('button').attr('id');
  
      update(variant_id,qty,0); // removing the variant
      
      if(qty > 1) {               
        $(this).parent().next('.input-box').val(qty);
      } else {
        $(this).parent().next('.input-box').val(qty);
  
        $(this).hide();
        $(this).siblings('.cartTrash').show();
      }               
    });
  
    $('.cartPlus').click(function(e) {
      var qty = $(this).parent().prev('.input-box').val();
      qty = parseInt(qty)+parseInt(1);
      $(this).parent().prev('.input-box').val(qty);
      if(qty > 1) {
        $(this).parent().siblings('.minus').children('.cartTrash').hide();
        $(this).parent().siblings('.minus').children('.cartMinus').show();
        var variant_id=$(this).parent().parent('.inputwrap').siblings('.prod-btn').children('button').attr('id');
        update(variant_id,qty,1); // adding the variant
      }
    });
    
    $('.cartTrash').click(function(e){
      var variant_id=$(this).parent().parent('.inputwrap').siblings('.prod-btn').children('button').attr('id');
  
      update(variant_id, 0, 0); // deleting the variant       
    });
  
    fetchCart();
  });
  
  function update(variant_id, qty, action) {
    jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
      updates: {
        [variant_id]: qty,
      }
    }).done(function(){ 
      var prod=  $("#"+variant_id).parent().siblings('.prodwrap').children('.prodinfo').find('.prod-name').text();
  
      $("#itemtitle").text(prod);
      if(action == 1) {
        $('#actioncart').text('Added to cart!');
        $('.addedToCart_alert').fadeIn('fast',fadeOut);
      } else {
        if(qty > 0) {
          $('#actioncart').text('Updated the cart!');
          $('.addedToCart_alert').fadeIn('fast',fadeOut);
        } else {
          $("#"+variant_id).parent().siblings('.inputwrap').hide();
          $("#"+variant_id).parent('.prod-btn').show();
  
          $("#"+variant_id).show();
        }
      }
    });
  }
  
  function addtocart(param, isSellingPlanAvailable = false) {
    $(param).addClass('disabled');
    
    const variant_id = param.id;
  
    const payload = {
      id: variant_id,
      quantity: 1,
    }
  
    if (isSellingPlanAvailable === true) {
      payload.selling_plan = $(param).parent()?.find('[name="selling-plan-id"]')?.val();
    }
    
  
    jQuery.post('/cart/add.js', {
      items: [payload]  
    }).done(function(e){              
      $(param).removeClass('disabled');
      $(param).hide();
      $(param).parent().siblings('.inputwrap').css('display','inline-block');
      $(param).parent().siblings('.inputwrap').find('.input-box').val(1);            
  
      var prod=  $(param).parent().siblings('.prodwrap').children('.prodinfo').find('.prod-name').text();
      $('#actioncart').text('Added to cart!');
      $("#itemtitle").text(prod);
      $('.addedToCart_alert').fadeIn('fast',fadeOut);
    });
  }
  
  function fetchCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Loop through the cart items and log each item's variant ID and quantity
        cart.items.forEach(item => {
          var param = $(`button[id="${item.variant_id}"]`);
          
          if(param) {
            $(param).hide();
            $(param).parent().siblings(".inputwrap").css("display", "inline-block");
            $(param).parent().siblings(".inputwrap").find(".input-box").val(item.quantity);
  
            if(item.quantity == 1) {
              $(param).parent().siblings(".inputwrap").find('.cartTrash').css("display", "inline-block");
              $(param).parent().siblings(".inputwrap").find('.cartMinus').css("display", "none");
            } else {
              $(param).parent().siblings(".inputwrap").find('.cartMinus').css("display", "inline-block");
              $(param).parent().siblings(".inputwrap").find('.cartTrash').css("display", "none");
            }
  
            if ($(param).parent().siblings(".inputwrap").is('[preorder-input-wrap]')) {
              $(param).parent().siblings(".inputwrap").addClass('preorder-wrap');
            }
          }
        });
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
  }
  
  /*function scrollfn() {
   
    if(gettingClicked == 0) {
      const items = document.querySelectorAll('.acces-prodwrap');
      const tabs = document.querySelectorAll('.navtab-item');
  
      const container = document.querySelector('.access-mid-right');
      const containerTop = container.scrollTop;
      const containerBottom = containerTop + container.clientHeight;
  
      let activeTab = null; // Track the current active tab
  
      // Loop through each item and check if it's in the viewport
      items.forEach(item => {
        const rect = item.getBoundingClientRect(); // Use getBoundingClientRect() to get more precise positioning
        const itemTop = (rect.top + containerTop) - 400;
        const itemBottom = itemTop + item.clientHeight;
  
        // Check if at least 50% of the item is in the visible area of the container
        const isInView = itemTop < containerBottom && itemBottom > containerTop;
  
        if (isInView) {
          // If the item is in view, find the corresponding tab
          const correspondingTab = document.querySelector(`.navtab-item[data-nav-index="${item.id}"]`);
         // alert(correspondingTab);
          if (correspondingTab) {
            if (!activeTab) {
              activeTab = correspondingTab; // Mark the first active tab
            }
          }
        }
      });
  
      // Ensure only one tab is active at a time
      $(".navtab-item").removeClass("active");
  
      // Add the active class to the identified active tab
      if (activeTab) {
        alert('hhh');
        activeTab.classList.add('active');
      }
  
      moveBand();
    }
  
    gettingClicked = 0;
  }
*/

  
function scrollfn() {
  var scrollDistance = $(".access-mid-right").scrollTop();
  if (scrollDistance == 0) {
    scrollDistance = $(window).scrollTop(); // calculating for lanscape view as thee whole window is scrolling
  }
console.log('scroll distance',scrollDistance);
  if (scrollDistance >= 0 && scrollDistance <= 300) {
    $(".navtab-item").removeClass("active");
    $("#new").addClass("active");
  } else if (scrollDistance >= 300 && scrollDistance <= 600) {
    $(".navtab-item").removeClass("active");
    $("#bundelcoll").addClass("active");
  } else if (scrollDistance > 600 && scrollDistance <= 1300) {
    $(".navtab-item").removeClass("active");
    $("#activefit").addClass("active");
  } else if (scrollDistance > 1300 && scrollDistance <= 2500) {
    $(".navtab-item").removeClass("active");
    $("#comfortfit").addClass("active");
  } else if (scrollDistance > 2500  && scrollDistance <= 2900) {
    $(".navtab-item").removeClass("active");
    $("#chargingcable").addClass("active");
  }
  else if (scrollDistance > 2900) {
    $(".navtab-item").removeClass("active");
    $("#screenprotector").addClass("active");
  }
  moveBand();
}
    
  $(document).ready(function() {
    $(window).scroll(function() {
      if ($(this).scrollTop() > 245) {
        $('.access-mid-left').addClass('fixedOnTop');
      } else {
        $('.access-mid-left').removeClass('fixedOnTop');
      }
    })
  });
  
  $('#timepicker li').on('click', function() {  
    //max left scroll
    var maxScrollLeft=$("#timepicker").scrollLeft('#timepicker').prop('scrollWidth') - $("#timepicker").width();
    var left = $(this).offset().left;
  
    var width = $("#timepicker").width();
    var diff = left - width/3.5;
    $("#timepicker").scrollLeft($("#timepicker").scrollLeft() + diff);  
  });
  
  function moveBand() {
    var left = $('#timepicker').find('.active').offset().left;
  
    // console.log(left);
    var width = $("#timepicker").width();
    var diff = left - width/3.5;
    $("#timepicker").scrollLeft($("#timepicker").scrollLeft()+diff);
  }
    
  $(document).ready(function() {
    $(window).scroll(function() {
      var element = $('.access-mid-left');
  
      // Get the offset of the element from the top of the document
      var offset = element.offset();
  
      // Calculate the distance from the top of the window
      var distanceFromTop = offset.top - $(window).scrollTop();
  
      if (distanceFromTop > 130) {
        $("#comfortfit-watch, #charging-access, #active-watch").addClass('distanceTop');
      }
      //alert($(this).scrollTop());
      if ($(this).scrollTop() >= 95) {
        $('.access-mid-left').addClass('fixedOnTop');
      } else {
        click=0;
        $('.access-mid-left').removeClass('fixedOnTop');
      }
      scrollfn();
    });       
  });
  
  var click=0;
  $(document).ready(function() {
    // Replace '.your-element' with the selector for your element
    var element = $('.access-mid-left');
  
    // Get the offset of the element from the top of the document
    var offset = element.offset();
  
    // Calculate the distance from the top of the window
    var distanceFromTop = offset.top - $(window).scrollTop();
    if(distanceFromTop > 130) {
      $("#comfortfit-watch, #charging-access, #active-watch").addClass('distanceTop');
    }
  
    $('.access-mid-left').click(function() {    
      if(click>=1) {
        if(offset.top>=134) {           
          $("#comfortfit-watch, #charging-access, #active-watch").removeClass('distanceTop');
        } else if (distanceFromTop > 130) {
          $("#comfortfit-watch, #charging-access, #active-watch").addClass('distanceTop');
        } else if (distanceFromTop < 50) {
          $("#comfortfit-watch, #charging-access, #active-watch").removeClass('distanceTop');
        }
      }
      
      click=click+1;            
    })
  });  